
import { ComponentCreator, createComponentCreator, styleInject } from 'packages/css-component-modules';

const _css = `.AppBarContainer_8a264550db46cc71{background-color:var(--backgroundColor_68cab430a4e43c8a);height:48px;min-height:48px;padding:0 16px;display:flex;align-items:center;border-bottom:1px solid var(--borderBottomColor_bf60aa9ca6e60afd);position:relative;top:0;z-index:1;position:fixed;width:100%}.SectionCenter_1c96dc4f43ec7f95{flex-grow:1;height:32px;display:flex;align-items:center;justify-content:center}@media (min-width:600px){.AppBarContainer_8a264550db46cc71{padding:0 24px}}`;
styleInject(_css)

/** AppBarContainer Props */
export type AppBarContainerCCM = {
  /** AppBarContainer Component Custom Properties */
  '$backgroundColor': string;
  '$borderBottomColor': string;

  /** AppBarContainer Modifier Flags */
  // No modifiers classes found
};
/** Base AppBarContainer component */
export const AppBarContainer: ComponentCreator<AppBarContainerCCM> = createComponentCreator({
  "name": "AppBarContainer",
  "base": "AppBarContainer_8a264550db46cc71",
  "prop": {
    "$backgroundColor": "--backgroundColor_68cab430a4e43c8a",
    "$borderBottomColor": "--borderBottomColor_bf60aa9ca6e60afd"
  },
  "mod": {}
});


/** SectionCenter Props */
export type SectionCenterCCM = {
  /** SectionCenter Component Custom Properties */
  // No custom properties found

  /** SectionCenter Modifier Flags */
  // No modifiers classes found
};
/** Base SectionCenter component */
export const SectionCenter: ComponentCreator<SectionCenterCCM> = createComponentCreator({
  "name": "SectionCenter",
  "base": "SectionCenter_1c96dc4f43ec7f95",
  "prop": {},
  "mod": {}
});

